import { defineMessages } from 'react-intl';

export const messages: {
	descriptionJira: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionJiraConfluenceMsrNudgeNoCollaborators: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionJiraConfluenceMsrNudgeWithCollaborators: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionJiraGalaxia: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionJpdNudge: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionLoomNudge: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	doNotShowAgainButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	getStartedButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	joinButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	notInterestedButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	remindMeLaterButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	title: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleJiraConfluenceMsrNudge: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleJiraNudgeMsr: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleJpdNudge: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleLoomNudge: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleNotInterested: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleReminder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	title: {
		id: 'cross-join-nudges.request-access-prompt-flag.title',
		defaultMessage: 'Your team is now using {product}',
		description: 'Title of invite prompt flag to join Confluence or Jira',
	},
	titleReminder: {
		id: 'cross-join-nudges.request-access-prompt-flag.title-reminder',
		defaultMessage: 'Your team is working in {product}',
		description: 'Title of invite prompt flag to join Confluence or Jira',
	},
	titleNotInterested: {
		id: 'cross-join-nudges.request-access-prompt-flag.title-not-interested',
		defaultMessage: 'Your team is waiting for you in {product}',
		description: 'Title of invite prompt flag to join Confluence or Jira',
	},
	descriptionJira: {
		id: 'cross-join-nudges.request-access-prompt-flag.description-jira',
		defaultMessage:
			'Stay on top of your tasks, unify your project workflow and track your team progress in Jira.',
		description: 'Description of how Jira can be used to assist with Confluence projects',
	},
	joinButton: {
		id: 'cross-join-nudges.request-access-prompt-flag.join-button',
		defaultMessage: 'Join your team',
		description: 'Action to direct access or request access to Confluence or Jira',
	},
	remindMeLaterButton: {
		id: 'cross-join-nudges.request-access-prompt-flag.remind-me-later-button',
		defaultMessage: 'Remind me later',
		description: 'Title of the dismiss button in the request access prompt flag',
	},
	notInterestedButton: {
		id: 'cross-join-nudges.request-access-prompt-flag.not-interested-button',
		defaultMessage: 'Not interested',
		description:
			'Title of the dismiss button with a stronger tone in the request access prompt flag',
	},
	titleJpdNudge: {
		id: 'cross-join-nudges.request-access-prompt-flag.title-jpd-nudge',
		defaultMessage: 'Join your team in using Jira Product Discovery',
		description: 'Title of invite prompt flag to join Jira Product Discovery',
	},
	titleJiraNudgeMsr: {
		id: 'cross-join-nudges.request-access-prompt-flag.title-jira-nudge',
		defaultMessage: 'Join your team in using Jira',
		description: 'Title of invite prompt flag to join Jira',
	},
	descriptionJpdNudge: {
		id: 'cross-join-nudges.request-access-prompt-flag.description-jpd-nudge',
		defaultMessage:
			'Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery.',
		description:
			'Description of how Jira Product Discovery can be used to assist with Jira projects',
	},
	getStartedButton: {
		id: 'cross-join-nudges.request-access-prompt-flag.get-started-button',
		defaultMessage: 'Get started',
		description: 'Action to direct access or request access to a product',
	},
	doNotShowAgainButton: {
		id: 'cross-join-nudges.request-access-prompt-flag.do-not-show-again-button',
		defaultMessage: "Don't show again",
		description:
			'Title of the dismiss button with a stronger tone in the request access prompt flag',
	},
	descriptionJiraGalaxia: {
		id: 'cross-join-nudges.request-access-prompt-flag.description-jira-galaxia',
		defaultMessage:
			'Stay on top of your tasks, unify your space workflow and track your team progress in Jira.',
		description: 'Description of how Jira can be used to assist with Confluence projects',
	},
	titleJiraConfluenceMsrNudge: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-jira-confluence-msr-nudge',
		defaultMessage: 'Join your team in using Confluence',
		description: 'Title of invite prompt flag to join Confluence - MSR Nudge',
	},
	descriptionJiraConfluenceMsrNudgeNoCollaborators: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-no-collaborators',
		defaultMessage:
			'Create project pages to build a shared understanding for better decision-making.',
		description:
			'Description of how Confluence can be used to assist with Jira projects without collaborators',
	},
	descriptionJiraConfluenceMsrNudgeWithCollaborators: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-with-collaborators',
		defaultMessage:
			'Organize team knowledge, capture ideas, and share requirements for your Jira projects. ',
		description:
			'Description of how Confluence can be used to assist with Jira projects with collaborators',
	},
	titleLoomNudge: {
		id: 'cross-join-nudges.request-access-prompt-flag.title-loom-nudge',
		defaultMessage: 'Join your team on Loom',
		description: 'Title of invite prompt flag to join Loom',
	},
	descriptionLoomNudge: {
		id: 'cross-join-nudges.request-access-prompt-flag.description-loom-nudge',
		defaultMessage: 'Use Loom videos to summarize pages and share information.',
		description: 'Description of how Loom can be used to assist with Confluence',
	},
});
